"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsHandler = void 0;
// external
const React = require("react");
const react_1 = require("react");
// local
const ProductsContext_1 = require("../../contexts/ProductsContext");
const useClient_1 = require("../../../../../hooks/useClient");
const useSyncedData_1 = require("../../../../../hooks/useSyncedData");
const RetailLocationsContext_1 = require("../../contexts/RetailLocationsContext");
const isDeliveryProduct_1 = require("../../helpers/isDeliveryProduct");
const isServiceProduct_1 = require("../../helpers/isServiceProduct");
const OrderTypeContext_1 = require("../../contexts/OrderTypeContext");
const sortByProductPriorityAscending = (productA, productB) => (productA === null || productA === void 0 ? void 0 : productA.productPriority) - (productB === null || productB === void 0 ? void 0 : productB.productPriority);
const ProductsHandler = ({ children }) => {
    const client = (0, useClient_1.useClient)();
    const { retailLocation } = (0, react_1.useContext)(RetailLocationsContext_1.RetailLocationsContext);
    const { orderType } = (0, react_1.useContext)(OrderTypeContext_1.OrderTypeContext);
    const products = (0, useSyncedData_1.useSyncedData)(client.retailProducts.retrieveSyncedProductListForRetailLocation(retailLocation ? retailLocation.retailLocationId : null, orderType ? orderType : null));
    const contextValue = (0, react_1.useMemo)(() => {
        if (Array.isArray(products)) {
            // sort the products by their priority
            products.sort(sortByProductPriorityAscending);
            return {
                products: products.filter(p => !(0, isDeliveryProduct_1.isDeliveryProduct)(p, env.deliveryId) &&
                    !(0, isServiceProduct_1.isServiceProduct)(p, env.serviceId)),
                deliveryProduct: products.find(p => (0, isDeliveryProduct_1.isDeliveryProduct)(p, env.deliveryId)),
                serviceProduct: products.find(p => (0, isServiceProduct_1.isServiceProduct)(p, env.serviceId)) || null
            };
        }
        return {
            products: null,
            deliveryProduct: null,
            serviceProduct: null
        };
    }, [products]);
    return (React.createElement(ProductsContext_1.ProductsContext.Provider, { value: contextValue }, children));
};
exports.ProductsHandler = ProductsHandler;
//# sourceMappingURL=index.js.map